// extracted by mini-css-extract-plugin
module.exports = {"DataListItem":"DataListItem_DataListItem__-08el"};